// extracted by mini-css-extract-plugin
export var closebutton = "ImageCarouselModal-module--closebutton--91440";
export var modal = "ImageCarouselModal-module--modal--5d462";
export var modalcontainer = "ImageCarouselModal-module--modalcontainer--e02fc";
export var modalswiper = "ImageCarouselModal-module--modalswiper--3430b";
export var pagination = "ImageCarouselModal-module--pagination--77168";
export var rotatedevice = "ImageCarouselModal-module--rotatedevice--249a1";
export var rotatetext = "ImageCarouselModal-module--rotatetext--340fc";